module.exports = "/_next/static/images/CollectUserEventData@2x-0a497786c18cbb55e09624828a252c9e.png";